/* import __COLOCATED_TEMPLATE__ from './posting-create-application-codes.hbs'; */
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { all, dropTask } from 'ember-concurrency';
import { action, computed } from '@ember/object';

const CLASS_NAME = 'SH-c-posting-create-application-codes';

/**
 * @type {string}   constant for when we have a select item that is the default signifying on selection.
 */
const EDIT_STORY_CODES_MODAL__NOTHING_SELECTED = '- None -';

/**
 * This is for the user to updatae the application codes in the posting create direct hire workflow.
 */
export default class PostingCreateApplicationCodes extends Component {
  @service('states/routes/posting-create') state;
  @service('state-managers/routes/posting-create') stateManager;
  @service session;
  @service('commands/cost-code-commands') costCodeCommandsService;
  @service('commands/story-code-commands') storyCodeCommandsService;

  @tracked costCodes = [];
  @tracked storyCodes = [];

  @readOnly('state.areFormElementsDisabled') _areFormElementsDisabled;

  codesNoneOptionText = EDIT_STORY_CODES_MODAL__NOTHING_SELECTED;

  get className() {
    return CLASS_NAME;
  }

  @computed('state.updatedDirectCostCode.body','_costCodeOptions.[]')
  get selectedCostCodeValue() {
    return this._costCodeOptions.find(({ id }) => id == this.state.updatedDirectCostCode)?.body
      ?? EDIT_STORY_CODES_MODAL__NOTHING_SELECTED;
  }

  @computed('state.updatedDirectStoryCode.body','_storyCodeOptions.[]')
  get selectedStoryCodeValue() {
    return this._storyCodeOptions.find(({ id }) => id == this.state.updatedDirectStoryCode)?.body
      ?? EDIT_STORY_CODES_MODAL__NOTHING_SELECTED;
  }

  /**
   * This is the options for the select for selection for cost codes
   *
   * @type {Ember.MutableArray}
   */
  get _costCodeOptions() {
    return this.costCodes
      .filter((costCode) => {
        return !costCode.hidden;
      });
  }

  @computed('session.currentUser.company.doesRequireCostCodes','state.updatedDirectCostCode')
  get _isShowCostCodeRequiredErrorText() {
    return this.session.currentUser.company.doesRequireCostCodes && !this.state.updatedDirectCostCode;
  }

  /**
   * This is the options for the select for selection for story codes
   *
   * @type {Ember.MutableArray}
   */
  get _storyCodeOptions() {
    return this.storyCodes
      .filter((storyCode) => {
        return !storyCode.hidden;
      });
  }

  @dropTask
  *loadCodes() {
    const { company } = this.session.currentUser;
    const [
      costCodes,
      storyCodes,
    ] = yield all([
      this.costCodeCommandsService.getCostCodesForCompany(company),
      this.storyCodeCommandsService.getStoryCodesForCompany(company),
    ]);

    this.costCodes = costCodes;
    this.storyCodes = storyCodes;
  }

  @action
  onSelectCostCode(value) {
    this.stateManager.updateDirectCostCode(value?.id ?? null);
  }

  @action
  onSelectStoryCode(value) {
    this.stateManager.updateDirectStoryCode(value?.id ?? null);
  }
}
